import * as React from "react";
import {
    List, Datagrid, TextField, EditButton, ShowButton, Edit, Show,
    SimpleForm, SimpleShowLayout, TextInput, SelectInput,
    DateField, Filter, DeleteButton, ReferenceField, FunctionField
} from 'react-admin';
import { UpLoadFile, FirstImageField } from '../components/custom/UpLoadFile';

const QualificationFilter = (props) => (
    <Filter {...props}>
        <TextInput label="搜索标题" source="key" alwaysOn />
        <SelectInput label="状态" source="Status" choices={[
            { id: 'pending', name: '待审核' },
            { id: 'approved', name: '已通过' },
            { id: 'rejected', name: '已驳回' },
        ]} />
    </Filter>
);

export const AgriQualificationList = props => (
    <List {...props} filters={<QualificationFilter />} title="资质管理">
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="ProviderId" label="主体ID" />
            <TextField source="Title" label="资质标题" />
            <TextField source="Type" label="资质类型" />
            <FunctionField label="文件" render={record => record.FileUrls && record.FileUrls.length > 0 ? `${record.FileUrls.length}个文件` : ''} />
            <TextField source="Status" label="状态" />
            <TextField source="AuditRemark" label="审核备注" />
            <DateField source="CreateTime" label="上传时间" showTime />
            <EditButton />
            <ShowButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const AgriQualificationShow = props => (
    <Show {...props} title="资质详情">
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="ProviderId" label="主体ID" />
            <TextField source="Title" label="资质标题" />
            <TextField source="Type" label="资质类型" />
            <FunctionField label="文件URL" render={record => record.FileUrls ? record.FileUrls.join(', ') : ''} />
            <TextField source="Status" label="状态" />
            <TextField source="AuditRemark" label="审核备注" />
            <TextField source="Remark" label="备注" />
            <DateField source="CreateTime" label="上传时间" showTime />
            <DateField source="AuditTime" label="审核时间" showTime />
        </SimpleShowLayout>
    </Show>
);

export const AgriQualificationEdit = props => (
    <Edit {...props} title="编辑资质">
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="Title" label="资质标题" />
            <SelectInput source="Type" label="资质类型" choices={[
                { id: '营业执照', name: '营业执照' },
                { id: '农机证', name: '农机证' },
                { id: '操作证', name: '操作证' },
                { id: '其他', name: '其他' },
            ]} />
            <TextInput source="FileUrls" label="文件URL(逗号分隔)" />
            <SelectInput source="Status" label="审核状态" choices={[
                { id: 'pending', name: '待审核' },
                { id: 'approved', name: '已通过' },
                { id: 'rejected', name: '已驳回' },
            ]} />
            <TextInput source="AuditRemark" label="审核备注" />
            <TextInput source="Remark" label="备注" />
        </SimpleForm>
    </Edit>
);
